module.exports = __webpack_public_path__ + "img/banner1.dbc57f98.png";